import * as React from 'react';
import { IconProps, SIZE_MAP } from '../types';
import { cn } from '../../../utils/cn';

const CheckCircleFilledIcon = ({ size = 'lg', className, ...props }: IconProps) => {
  const px = SIZE_MAP[size];

  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-primary', className)}
      {...props}
    >
      <path
        d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25Z"
        fill="currentColor"
      />
      <path
        d="M15.9697 8.46967C16.2626 8.17678 16.7373 8.17678 17.0302 8.46967C17.3231 8.76256 17.3231 9.23732 17.0302 9.53022L11.0302 15.5302C10.7373 15.8231 10.2626 15.8231 9.96967 15.5302L6.96967 12.5302C6.67678 12.2373 6.67678 11.7626 6.96967 11.4697C7.26256 11.1768 7.73732 11.1768 8.03022 11.4697L10.4999 13.9394L15.9697 8.46967Z"
        fill="white"
      />
    </svg>
  );
};

export default CheckCircleFilledIcon;